import { Link } from "react-router-dom";

const SERVICE_LINKS = [
  { to: "/services#transcription", label: "Transcription" },
  { to: "/services#translation", label: "Translation" },
  { to: "/services#media", label: "Media Content" },
  { to: "/services#advertising", label: "Digital Advertising" },
  { to: "/learn", label: "Learn — Maths, Cooking, Art" },
];

const IMPACT_LINKS = [
  { to: "/our-work", label: "Our Work" },
  { to: "/our-work#reality", label: "The Reality We Work In" },
  { to: "/our-work#programs", label: "Programs" },
  { to: "/about", label: "About Us" },
];

const ACTION_LINKS = [
  { to: "/support?tab=pay", label: "Pay", testid: "footer-pay-link" },
  { to: "/support?tab=donate", label: "Donate", testid: "footer-donate-link" },
  { to: "/contact", label: "Contact", testid: "footer-contact-link" },
];

export default function Footer() {
  return (
    <footer className="bg-charcoal text-cream" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <p className="font-serif text-2xl font-bold">
              Pro<span className="italic text-sand">One</span>
            </p>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-cream/70">
              Professional services and transformative learning — and a registered
              nonprofit (2025) serving rural India with healthcare, education,
              relief, and language access.
            </p>
          </div>
          <nav aria-label="Services">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-sand/80">Services</p>
            <ul className="mt-4 space-y-2.5">
              {SERVICE_LINKS.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    className="text-sm text-cream/75 transition-colors duration-300 hover:text-cream"
                    data-testid={`footer-service-${l.label.split(" ")[0].toLowerCase()}-link`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          <nav aria-label="Impact">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-sand/80">Impact</p>
            <ul className="mt-4 space-y-2.5">
              {IMPACT_LINKS.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    className="text-sm text-cream/75 transition-colors duration-300 hover:text-cream"
                    data-testid={`footer-impact-${l.label.split(" ")[0].toLowerCase()}-link`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          <nav aria-label="Actions">
            <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-sand/80">Act</p>
            <ul className="mt-4 space-y-2.5">
              {ACTION_LINKS.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    className="text-sm font-semibold text-cream transition-colors duration-300 hover:text-sand"
                    data-testid={l.testid}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
        <div className="mt-14 flex flex-col gap-3 border-t border-cream/15 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-cream/50">
            © {new Date().getFullYear()} ProOne Solutions · www.proonesolutions.com
          </p>
          <p className="max-w-md text-xs leading-relaxed text-cream/50">
            People on this site are named by first name only, and field locations are
            never published — dignity and privacy by policy.
          </p>
        </div>
      </div>
    </footer>
  );
}
